/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceOperationQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceOperationQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceOperationQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceOperationQueryOperator>): ResourceOperationQueryOperator {
        let obj = Object.assign(new ResourceOperationQueryOperator(), model);
        ResourceOperationQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceOperationQueryOperator>): ResourceOperationQueryOperator {
        if (!model) return null;
        return ResourceOperationQueryOperator.newInstance(<ResourceOperationQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceOperationQueryOperator) {
        if (!obj) return;

        models.ResourceOperationQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceOperationQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceOperationQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource operations to include
     */
    resource_operations: Array<string>;

}
